//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import layout from '~/mixins/layout'

export default {
  mixins: [layout],
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default() {},
    },
    type: {
      type: String,
      default: 'PageNavigation',
    },
    pageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      navScroll: {
        scroll: null,
        width: null,
        bounceWidth: 18,
      },
      isFixed: false,
      originalTop: 0,
      lastScrollPosition: 0,
    }
  },
  computed: {
    isScrollableLeft() {
      if (!this.navScroll.scroll) {
        return false
      }
      const isScrollable = this.navScroll.scroll > this.navScroll.bounceWidth
      return isScrollable
    },
    isScrollableRight() {
      if (!this.navScroll) {
        return false
      }
      const isScrollable = this.navScroll.scroll < this.navScroll.width
      return isScrollable
    },
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
  mounted() {
    const navItemWrapper = this.$refs.navItemWrapper
    if (navItemWrapper) {
      this.$refs.navItemWrapper.addEventListener('scroll', (e) => {
        this.navScroll.scroll = e.target.scrollLeft
        this.navScroll.width = e.target.scrollWidth - e.target.offsetWidth
      })
    }
    this.originalTop =
      this.$refs.navigationBar?.getBoundingClientRect().top + window.scrollY
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const currentScroll = window.scrollY
      const sectionsTopics = document.querySelectorAll(
        'section[data-variant="articletopic"]'
      )
      // eslint-disable-next-line no-var
      var lastSection = null
      if (sectionsTopics && sectionsTopics.length !== 0) {
        lastSection = sectionsTopics[sectionsTopics.length - 1]
      } else {
        lastSection = document.getElementById('hearing-tests')
      }
      const limitRect =
        lastSection?.getBoundingClientRect()?.top + lastSection?.offsetHeight

      if (currentScroll > this.originalTop - 120 && limitRect > 120) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
      this.lastScrollPosition = currentScroll
    },
  },
}
